import { render, staticRenderFns } from "./GooglePreviewBusinessV2.vue?vue&type=template&id=050c3ede&scoped=true&"
import script from "./GooglePreviewBusinessV2.vue?vue&type=script&lang=ts&"
export * from "./GooglePreviewBusinessV2.vue?vue&type=script&lang=ts&"
import style0 from "./GooglePreviewBusinessV2.vue?vue&type=style&index=0&id=050c3ede&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050c3ede",
  null
  
)

export default component.exports